import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import freeTrialService from '../../services/free-trial-service';
import './TrialNotificationBanner.scss';

const TrialNotificationBanner = () => {
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  const customerId = sessionStorage.getItem('customerId');

  useEffect(() => {
    if (!customerId) return;
    if (sessionStorage.getItem('trialJustClaimed') === 'true') {
      setStatus({ eligible: false, claimed: true });
      return;
    }
    freeTrialService.getTrialStatus().then(s => {
      setStatus(s);
      if (s?.claimed === true) sessionStorage.setItem('trialJustClaimed', 'true');
    });
  }, [customerId]);

  if (!status || status.claimed || !status.eligible) return null;

  const getDaysLeft = () => {
    if (!status.eligibleUntil) return 0;
    return Math.max(0, Math.ceil((new Date(status.eligibleUntil) - new Date()) / (1000 * 60 * 60 * 24)));
  };

  return (
    <div className="trial-banner active">
      <div className="trial-banner-content">
        <span className="trial-icon">🎁</span>
        <div className="trial-text">
          <strong>Welcome Gift!</strong> Get 5 immunity shots for just ₹100
          <span className="trial-expiry"> — {getDaysLeft()} day{getDaysLeft() !== 1 ? 's' : ''} left</span>
        </div>
        <button className="trial-claim-btn" onClick={() => navigate('/subscriptions')}>
          Claim for ₹100
        </button>
      </div>
    </div>
  );
};

export default TrialNotificationBanner;
